import { Alert, Card, DatePicker, Form } from 'antd';
import styled from 'styled-components';

export const Title = styled.h2`
  font-weight: 400;
  text-align: center;
  width: 100%;
`;

export const StyledDatePicker = styled<any>(DatePicker)`
  width: 100%;
  height: 36px;
`;

export const Remarks = styled.p`
  color: ${props => props.theme.palette.text.grey};
`;

export const StyledAlert = styled(Alert)`
  margin-top: 16px;
  margin-bottom: 20px;
  border-radius: 4px;
  &.ant-alert-info {
    background-color: #d8e8ff;
    border: 1px solid #91d5ff;
    .ant-alert-icon {
      color: #1890ff;
    }
  }
`;

export const StyledCard = styled(Card)`
  border: 1px solid ${props => props.theme.palette.background.grey2};
  margin-bottom: 20px;
  border-radius: 8px;
  background: ${props => props.theme.palette.background.primary80};

  .ant-card-body {
    padding: 10px 15px;
  }
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 5px;
  &.custom-apikey {
    &.ant-form-item-has-error {
      .ant-input-textarea-show-count:after {
        color: inherit;
        margin-bottom: 0px;
      }
      .ant-input-textarea-show-count[data-count='128 / 128'] {
        color: #d31e47 !important;
      }
    }
    textarea {
      resize: none;
    }
  }
`;

export const ErrorMessage = styled.div`
  color: ${props => props.theme.palette.text.attention};
  span.icon-wraper {
    margin-right: 4px;
  }
`;
